export default __webpack_public_path__ + "static/media/playground1.c1877e5c.png";